import { render, staticRenderFns } from "./BaseTable.vue?vue&type=template&id=2cdbbbda&scoped=true"
import script from "./BaseTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BaseTable.vue?vue&type=style&index=0&id=2cdbbbda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdbbbda",
  null
  
)

export default component.exports